var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiamondMine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#212121"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9997 10L13.333 14L15.9997 22.6667L18.6663 14L16.9997 10",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3332 10C19.5402 10 19.7444 10.0482 19.9295 10.1408C20.1147 10.2333 20.2757 10.3677 20.3999 10.5333L22.3999 13.2C22.5714 13.4288 22.6649 13.7066 22.6664 13.9926C22.668 14.2785 22.5776 14.5574 22.4086 14.788L17.0819 22.112C16.9584 22.2837 16.7958 22.4235 16.6077 22.5199C16.4195 22.6164 16.211 22.6667 15.9996 22.6667C15.7881 22.6667 15.5797 22.6164 15.3915 22.5199C15.2033 22.4235 15.0407 22.2837 14.9172 22.112L9.59056 14.788C9.42164 14.5573 9.33135 14.2784 9.33303 13.9925C9.33471 13.7065 9.42827 13.4287 9.5999 13.2L11.5986 10.5353C11.7227 10.3692 11.8839 10.2343 12.0693 10.1414C12.2547 10.0484 12.4592 10 12.6666 10H19.3332Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33301 14H22.6663",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamondMine);
export default __webpack_public_path__ + "static/media/diamond_mine.3f35b688fa658f33c026a20e2f77e119.svg";
export { ForwardRef as ReactComponent };